import { connect } from 'react-redux';

import {
  changeQuickShopSelectedVariant,
  changeQuickShopVisibility,
} from '../actions';
import QuickShopModal from '../components/QuickShopModal';

const mapStateToProps = state => {
  return {
    isOpen: state.quickShopIsOpen,
    variants: state.quickShopVariants,
    selectedVariant: state.selectedQuickShopVariant,
    currentOrder: state.currentOrder,
    showExciseTaxDisclaimer: state.showExciseTaxDisclaimer,
    splitTreatments: state.splitTreatments,
    taxonName: state.taxonName,
  };
};

const mapDispatchToProps = dispatch => ({
  closeQuickShopModal: () => {
    dispatch(changeQuickShopVisibility(false));
  },
  changeSelectedVariant: variant => {
    dispatch(changeQuickShopSelectedVariant(variant));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuickShopModal);
